module.exports = __webpack_public_path__ + "static/media/rabbit.2d1825d2.png";